import {
  BookmarkBorder as BookmarkBorderIcon,
  FiberManualRecord as FiberManualRecordIcon,
FavoriteBorderRounded as FavoriteBorderRoundedIcon,
  MoreVert as MoreVertIcon,
  Public as PublicIcon
} from '@mui/icons-material';
import {
  Avatar,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Divider,
  Grid,
  Box,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PostUtil } from 'src/pages/new-post-new/post-util';
import { useState } from 'react';
import { CommonHelper } from 'src/utils/commonHelper';
import BlueskyRetweetIcon from '../../../../assets/twitter_retweet.svg';
import BlueskyCommentIcon from '../../../../assets/comment.svg';
import Blueskyshare from '../../../../assets/instagram-share-icon.svg';
import { useTranslation } from 'react-i18next';

const BlueskyPostPreview = ({ data }) => {
  const { t: translate } = useTranslation();
  let mediaFiles = CommonHelper.ProcessMediaUrl(data?.media_url)?.media_data || [];
  const [showFullDescription, setShowFullDescription] = useState(false);
  const handleToggleDescription = () => {
    setShowFullDescription(!showFullDescription);
  };

  const getBorderRadius = (i, totalMedia) => {
    const radius = '16px';
    if (totalMedia === 1) return radius;
    if (totalMedia === 2) return i === 0 ? `${radius} 0 0 ${radius}` : `0 ${radius} ${radius} 0`;
    if (totalMedia === 3) {
      if (i === 0) return `${radius} 0 0 0`;
      if (i === 1) return `0 ${radius} 0 0`;
      if (i === 2) return `0 0 ${radius} ${radius}`;
    }
    if (totalMedia >= 4) {
      if (i === 0) return `${radius} 0 0 0`;
      if (i === 1) return `0 ${radius} 0 0`;
      if (i === 2) return `0 0 0 ${radius}`;
      if (i === 3) return `0 0 ${radius} 0`;
    }
    return '0';
  };

  const mediaView = () => {
    let view = [];
    let xWidth = 6;
    let isThreeMedia = false;
    const totalMedia = mediaFiles.length;
    const remainingMediaCount = totalMedia > 4 ? totalMedia - 4 : 0;

    switch (totalMedia) {
      case 1:
        xWidth = 12;
        break;
      case 2:
      case 4:
      default:
        xWidth = 6;
        break;
      case 3:
        isThreeMedia = true;
        break;
    }

    if (isThreeMedia) {
      const gridItemStyle = { position: 'relative', overflow: 'hidden' };
      view = (
        <Grid container spacing={0.2} sx={{ position: 'relative' }}>
          <Grid item xs={6} sx={gridItemStyle}>
            {renderMedia(mediaFiles[0], 0, 300)}

          </Grid>
          <Grid item xs={6}>
            <Grid container direction="column" spacing={0.2}>
              {[1, 2].map((i) => (
                <Grid item xs={12} key={i} sx={gridItemStyle}>
                  {renderMedia(mediaFiles[i], i, 150)}
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      );
    } else {
      view = mediaFiles?.slice(0, 4).map((media, i) => {
        const gridItemStyle = {
          maxWidth: 500,
          maxHeight: 250,
          overflow: 'hidden',
          position: 'relative',
          borderRadius: getBorderRadius(i, totalMedia),
        };
        return (
          <Grid
            item
            xs={xWidth}
            key={i}
            sx={gridItemStyle}
          >
            {renderMedia(media, i, 250, remainingMediaCount)}
          </Grid>
        );
      });
    }

    return (
      <Grid container spacing={0.2} sx={{ position: 'relative' }}>
        {view}
      </Grid>
    );
  };

  const renderMedia = (media, index, height, remainingCount = 0) => {
    const src = media?.url || media;
    const isVideo = media?.type === PostUtil.MediaType.VIDEO || (data?.media_data?.media_data && data.media_data.media_data[index]?.type === PostUtil.MediaType.VIDEO);
    const isImage = media?.type === PostUtil.MediaType.IMAGE || (!media.type && typeof media === 'string') || (data?.media_data?.media_data && data.media_data.media_data[index]?.type === PostUtil.MediaType.IMAGE);

    const mediaStyle = {
      width: '100%',
      height,
      objectFit: 'cover',
      borderRadius: 'inherit',
    };

    let borderRadiusForItem = 'inherit';
    if (mediaFiles.length === 3 && index === 0) borderRadiusForItem = '12px 0 0 12px';
    if (mediaFiles.length === 3 && index === 1) borderRadiusForItem = '0 12px 0 0';
    if (mediaFiles.length === 3 && index === 2) borderRadiusForItem = '0 0 12px 0';

    return (
      <>
        {isImage ? (
          <img
            src={src}
            alt={`media-${index}`}
            style={{ ...mediaStyle, borderRadius: borderRadiusForItem }}
          />
        ) : isVideo ? (
          <video
            src={src}
            controls
            style={{ ...mediaStyle, borderRadius: borderRadiusForItem }}
          />
        ) : null}

        {index === 3 && remainingCount > 0 && (
          <Typography
            variant="h2"
            color="white"
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1,
              borderRadius: 'inherit',
            }}
          >
            +{remainingCount}
          </Typography>
        )}
      </>
    );
  };

  const theme = useTheme();
  const respwidth = useMediaQuery(theme.breakpoints.up('xl'));
  const ConnectedProfiles = data.connected_profile_details;
  const ProfileTime = () => {
    return (
      <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" sx={{ gap: '0.3rem' }}>
        <Typography variant="span">{translate('preview.just_now')}</Typography>
        <FiberManualRecordIcon sx={{ fontSize: 5, mt: '0.6rem' }} />
        <PublicIcon sx={{ fontSize: 15, mt: '0.3rem' }} />
      </Stack>
    );
  };

  return (
    <Stack container justifyContent="center" alignItems="center">
      <Card
        sx={{
          maxWidth: 500,
          minWidth: respwidth ? 400 : null,
          boxShadow: 3,
          borderRadius: 2,
          border: 'none',
          borderColor: theme.palette.preview.postcard.color,
        }}
      >
        <CardHeader
          avatar={
            <Avatar
              src={
                ConnectedProfiles.connected_profile_image
                  ? ConnectedProfiles.connected_profile_image
                  : ConnectedProfiles.connected_profile_name || ConnectedProfiles.connected_profile_id
              }
              alt={
                ConnectedProfiles.connected_profile_name
                  ? ConnectedProfiles.connected_profile_name
                  : ConnectedProfiles.connected_profile_id
              }
              sx={{
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                height: 40,
                width: 40,
                bgcolor: theme.palette.primary.main,
              }}
              style={{ color: 'white' }}
            />
          }
          title={ConnectedProfiles?.connected_profile_name}
          sx={{ fontSize: { xl: 15, lg: 13, md: 11, sm: 9, xs: 7 } }}
          subheader={<ProfileTime />}
          action={<MoreVertIcon sx={{ mt: 1 }} />}
        />
        <CardContent sx={{ pt: 1, pb: 1 }}>
          <Typography
            noWrap={!showFullDescription}
            sx={{
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: showFullDescription ? 'initial' : 2,
              overflow: 'hidden',
              WebkitBoxDecorationBreak: 'clone',
              whiteSpace: 'pre-line',
              textOverflow: 'ellipsis',
              fontSize: '0.875rem',
            }}
          >
            {CommonHelper.ParseDescription(data.description)}
          </Typography>
          {!showFullDescription && data.description.length > 100 && (
            <Typography
              variant="body1"
              sx={{
                fontWeight: 700,
                textDecoration: 'underline',
                cursor: 'pointer',
                fontSize: '0.875rem',
                color: theme.palette.primary.main,
              }}
              onClick={handleToggleDescription}
            >
              {translate('preview.show_more')}
            </Typography>
          )}
          {showFullDescription && (
            <Typography
              variant="body1"
              sx={{
                fontWeight: 700,
                textDecoration: 'underline',
                cursor: 'pointer',
                fontSize: '0.875rem',
                color: theme.palette.primary.main,
              }}
              onClick={handleToggleDescription}
            >
              {translate('preview.show_less')}
            </Typography>
          )}
        </CardContent>
        <CardMedia sx={{ pl: 2, pr: 2 }}>{mediaView()}</CardMedia>
        <CardActions disableSpacing sx={{ display: 'block' }}>
          <Divider />
          <Stack direction="row" style={{ justifyContent: 'space-between', align: 'center' }}>
           
            <Paper sx={{ display: 'flex', alignItems: 'center' }}>
              <FavoriteBorderRoundedIcon sx={{ marginRight: '0.5rem', color: theme.palette.preview.postcard.icon }} />
            </Paper>
             <Paper sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
              <img
                src={BlueskyCommentIcon}
                style={{ height: 'auto', width: '100%', maxWidth: '22px', maxHeight: '22px', marginLeft: '1rem' }}
              />
            </Paper>
             <Paper sx={{ display: 'flex', alignItems: 'center' }}>
              <img
                src={BlueskyRetweetIcon}
                style={{ height: 'auto', width: '100%', maxWidth: '22px', maxHeight: '22px', marginLeft: '0.5rem' }}
              />
            </Paper>
             <Paper sx={{ display: 'flex', alignItems: 'center' }}>
              <img
                src={Blueskyshare}
                style={{ height: 'auto', width: '100%', maxWidth: '22px', maxHeight: '22px', marginLeft: '0.5rem' }}
              />
            </Paper>
          </Stack>
          {data.has_comment && data.comment_description && (
              <>
                <Divider sx={{ mt: 0.5, borderBottom: '1px solid #ddd' }} />
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '0.5rem',
                    marginTop: '8px',
                  }}
                >
                  <Avatar
                    src={
                      ConnectedProfiles.connected_profile_image
                        ? ConnectedProfiles.connected_profile_image
                        : ConnectedProfiles.connected_profile_name || ConnectedProfiles.connected_profile_id
                    }
                    alt={
                      ConnectedProfiles.connected_profile_name
                        ? ConnectedProfiles.connected_profile_name
                        : ConnectedProfiles.connected_profile_id
                    }
                    sx={{
                      textAlign: 'flex-start',
                      height: 30,
                      width: 30,
                      bgcolor: theme.palette.primary.main,
                    }}
                  />
                  <Box sx={{ width: '100%' }}>
                    <Box
                      sx={{
                        padding: 1,
                        borderRadius: '8px',
                        border: `1px solid ${theme.palette.text.border}`,
                        background: theme.palette.background.default,
                      }}
                    >
                      <Typography variant="body2" sx={{ fontWeight: 800 }}>
                        {ConnectedProfiles?.connected_profile_name}
                      </Typography>
                      <Typography
                        variant="body2"
                        style={{
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: 1,
                          overflow: 'hidden',
                          WebkitBoxDecorationBreak: 'clone',
                          whiteSpace: 'pre-line',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {CommonHelper.ParseDescription(data.comment_description)}
                      </Typography>
                    </Box>
                    <Stack spacing={1} direction="row" justifyContent="flex-start" alignItems="flex-start">
                      <Typography variant="body2" sx={{ fontWeight: 800, color: 'text.secondary' }}>
                        {translate('preview.like')}
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 800, color: 'text.secondary' }}>
                        {translate('preview.reply')}
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        {translate('preview.just_now')}
                      </Typography>
                    </Stack>
                  </Box>
                </Box>
              </>
            )}
        </CardActions>
      </Card>
    </Stack>
  );
};

export default BlueskyPostPreview;
